import { LabelChip, Tooltip, Typography, Stack } from '@cast/design-system';

type Props = {
  left: string;
  right: string;
  tooltipContent: string[];
};
export const StatusChip = ({ left, right, tooltipContent }: Props) => {
  return (
    <Stack direction="row" gap={4}>
      <Tooltip
        arrow
        placement="top-start"
        title={
          <Stack>
            {tooltipContent.map((item) => (
              <Typography key={item} variant="P12R" fontWeight={600}>
                {item}
              </Typography>
            ))}
          </Stack>
        }
      >
        <LabelChip size="xs">
          {left}: {right}
        </LabelChip>
      </Tooltip>
    </Stack>
  );
};
